import computerCheck from './svgs/computerCheck.svg';
import computerList from './svgs/computerList.svg';

export const connectSoftwareImageMap = {
  computerCheck: {
    src: computerCheck,
    alt: 'computerCheck',
  },
  computerList: {
    src: computerList,
    alt: 'computerList',
  },
};
